<template>
    <div class="header-cast-detail">
        <div class="header-cast-detail__image">
            <img 
                v-if="image" 
                :src="image" 
                alt="photo" 
                loading="lazy"
                class="header-cast-detail__photo"
            >
            <common-icon v-else class="credit-content__image" :icon-name="'IconNoPerson'" />
        </div>
        <div class="header-cast-detail__info">
            <h1 v-if="title" class="header-cast-detail__title">{{ title }}</h1>
            <p v-if="info" class="header-cast-detail__description">{{ info }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useCastPageStore } from "@/stores/CastPage";
    import { useI18n } from "vue-i18n";
    import { LangCodes } from "@/common/types/languages";
    import { Strings } from "@/locales/types/enums/strings";

    const CastPageStore = useCastPageStore();
    const {
        getCurrentCastItemDetail
    } = storeToRefs(CastPageStore);

    const { t, locale } = useI18n();


    const title = computed((): string | null => getCurrentCastItemDetail.value?.person?.name ?? null);
    const image = computed((): string => getCurrentCastItemDetail.value?.image ? `${getCurrentCastItemDetail.value?.image}&width=260` : '');
    const birthPlace = computed((): string | null => getCurrentCastItemDetail.value?.person?.birthPlace ? `${t(Strings.CAST_PAGE_BORN)}: ${getCurrentCastItemDetail.value?.person?.birthPlace}` : null);
    const date = computed((): string | null => {
        const dateFormat = locale.value === LangCodes.FR ? 'DD.MM.YYYY' : 'MM/DD/YYYY';
        let deathDate = null;
        let birthDate = null;
        
        try {
            if(getCurrentCastItemDetail.value?.person?.deathDate) {
                deathDate = TimeUtils.extractTimestamp(getCurrentCastItemDetail.value?.person?.deathDate);
            } 
            
            if(getCurrentCastItemDetail.value?.person?.birthDate) {
                birthDate = TimeUtils.extractTimestamp(getCurrentCastItemDetail.value?.person?.birthDate);
            }
        } catch (error) {
            console.error('Error extracting timestamps:', error);
            return null;
        }

        return [birthDate, deathDate].filter(item => item !== null).map(item => item ? TimeUtils.getMoment(locale.value, item).format(dateFormat) : null).join(' - ');
    });
    const info = computed((): string => {
        return [
            birthPlace.value,
            date.value,
        ].filter(item => item !== null).join(', ');
    });
</script>

<style lang="scss">
    @import url("styles.scss");
</style>
